import { render, staticRenderFns } from "./TwoButtonGoTop.vue?vue&type=template&id=2cbdd26c&"
import script from "./TwoButtonGoTop.vue?vue&type=script&lang=js&"
export * from "./TwoButtonGoTop.vue?vue&type=script&lang=js&"
import style0 from "./TwoButtonGoTop.vue?vue&type=style&index=0&id=2cbdd26c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports